import React from 'react';
import PropTypes from 'prop-types';

export const MilitaryHistoryAccordionItem = ({ formData }) => {
  const showMilitaryHistory = formData?.veteranPreviousNames?.length >= 2;

  if (!showMilitaryHistory) {
    return null;
  }

  return (
    <va-accordion-item level={5} bordered header="Military history">
      <p>You may need to submit this document:</p>
      <ul>
        <li>
          <strong>If the Veteran served under more than 2 names</strong>, you’ll
          need to submit this document.
          <span className="vads-u-display--block">
            Statement in Support of Claim (VA Form 21-4138)
          </span>
          <span className="vads-u-display--block">
            <va-link
              href="https://www.va.gov/find-forms/about-form-21-4138"
              external
              text="Get VA Form 21-4138 to download"
            />
          </span>
        </li>
      </ul>
    </va-accordion-item>
  );
};

MilitaryHistoryAccordionItem.propTypes = {
  formData: PropTypes.object,
};
